import { retailerDataForBots } from '@/features/shared/constants/ungatedSEO'
import { getCanonicalUrl, SEO_CONSTANTS } from '@/features/shared/utils/seo/seoConfig'

export const getRetailerShopTitle = (
  storeSlug: string | undefined,
  storeName: string | undefined,
) => {
  const storeCategory = getStoreCategory(storeSlug)
  return `${storeName} ${storeCategory} | Same-Day Delivery with Shipt`
}
export const getStoreCategory = (storeSlug: string | undefined): string =>
  retailerDataForBots[String(storeSlug)]?.category ?? 'Delivery'

type BreadcrumbItem = { name: string; item: string }

export const getRetailerShopBreadcrumbs = (
  storeSlug: string | undefined,
  storeName: string | undefined,
  additionalItems: BreadcrumbItem[] = [],
) => {
  const rhpName = getRetailerShopTitle(storeSlug, storeName)
  return {
    '@type': 'BreadcrumbList',
    '@context': 'https://schema.org',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: SEO_CONSTANTS.rootDomain,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Shop',
        item: `${SEO_CONSTANTS.rootDomain}/shop`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: rhpName,
        item: getCanonicalUrl(`/shop/${storeSlug}`),
      },
      ...additionalItems.map((breadcrumb, i) => ({
        '@type': 'ListItem',
        position: i + 4,
        ...breadcrumb,
      })),
    ],
  }
}
